var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNopendingrequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 83,
    viewBox: "0 0 120 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 82.4783C93.1371 82.4783 120 72.7453 120 60.7391C120 48.7329 93.1371 39 60 39C26.8629 39 0 48.7329 0 60.7391C0 72.7453 26.8629 82.4783 60 82.4783Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1573 21.9083C59.9358 20.4077 61.3112 19.3052 62.9451 18.8718L73.7052 16.018C76.6947 15.2252 79.7971 16.8346 80.8704 19.7353L84.7337 30.1755C85.3204 31.7609 85.211 33.5202 84.4326 35.0208L68.7492 65.2516C67.2232 68.1931 63.6016 69.3405 60.6602 67.8145L46.0368 60.2281C43.0954 58.7021 41.9479 55.0806 43.4739 52.1391L59.1573 21.9083Z",
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.0621,
    cy: 32.9744,
    r: 5.69624,
    transform: "rotate(27.4197 71.0621 32.9744)",
    fill: "#BDC6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.299 15.469C89.3227 15.2531 88.3563 15.8696 88.1404 16.8458V16.8458C87.9245 17.8221 88.541 18.7885 89.5172 19.0044L95.3784 20.3004C96.3547 20.5162 97.3211 19.8998 97.537 18.9235V18.9235C97.7528 17.9473 97.1364 16.9808 96.1601 16.765L90.299 15.469Z",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5369 3.72962C84.7527 2.75334 85.7192 2.13691 86.6954 2.35277V2.35277C87.6717 2.56864 88.2881 3.53506 88.0723 4.51134L86.7763 10.3725C86.5604 11.3488 85.594 11.9652 84.6177 11.7494V11.7494C83.6415 11.5335 83.025 10.5671 83.2409 9.59079L84.5369 3.72962Z",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2197 10.3131C59.715 9.52457 61.4736 9.40344 63.0629 9.97947L75.3426 14.4302C78.2504 15.4841 79.8806 18.5756 79.1078 21.5703L75.8441 34.2174C75.4217 35.8542 74.3284 37.2369 72.8331 38.0255L38.9196 55.9087C35.9885 57.4544 32.3593 56.3312 30.8136 53.4001L21.7976 36.3023C20.252 33.3712 21.3751 29.742 24.3063 28.1964L58.2197 10.3131Z",
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.78 51.345L42.7903 49.2303C44.2559 48.4574 44.8175 46.6429 44.0447 45.1773L36.2372 30.3714C35.4644 28.9059 33.6498 28.3443 32.1842 29.1171L28.1738 31.2319C26.7083 32.0047 26.1467 33.8193 26.9195 35.2848L34.727 50.0907C35.4998 51.5563 37.3144 52.1179 38.78 51.345Z",
    fill: "#BDC6DB",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2793 25.8828L49.3623 42.7409",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.8352,
    cy: 25.5882,
    r: 5.69624,
    transform: "rotate(62.1964 62.8352 25.5882)",
    fill: "#BDC6DB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.3025,
    cy: 47.3709,
    r: 14.3982,
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6426 40.1711C87.6426 39.2536 88.3864 38.5098 89.3039 38.5098V38.5098C90.2214 38.5098 90.9652 39.2536 90.9652 40.1711V46.8164C90.9652 47.734 90.2214 48.4778 89.3039 48.4778V48.4778C88.3864 48.4778 87.6426 47.734 87.6426 46.8164V40.1711Z",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6426 54.5691C87.6426 55.4867 88.3864 56.2305 89.3039 56.2305V56.2305C90.2214 56.2305 90.9652 55.4867 90.9652 54.5691V54.5691C90.9652 53.6516 90.2214 52.9078 89.3039 52.9078V52.9078C88.3864 52.9078 87.6426 53.6516 87.6426 54.5691V54.5691Z",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopendingrequest);
export default __webpack_public_path__ + "static/media/nopendingrequest.a00d43259e8770ac0242aad0946dc146.svg";
export { ForwardRef as ReactComponent };